export const popupConstants = {
  DETAIL_REQUEST: "POPUP_DETAIL_REQUEST",
  DETAIL_SUCCESS: "POPUP_DETAIL_SUCCESS",
  DETAIL_FAILURE: "POPUP_DETAIL_FAILURE",

  SAVE_CLOSE_REQUEST: "POPUP_SAVE_CLOSE_REQUEST",
  SAVE_CLOSE_SUCCESS: "POPUP_SAVE_CLOSE_SUCCESS",
  SAVE_CLOSE_FAILURE: "POPUP_SAVE_CLOSE_FAILURE"
};
